import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import { ArrowLeft } from 'lucide-react';

function TermsPage() {
  const { theme, currentThemeName } = useTheme();
  const { t } = useLanguage();
  const isDark = currentThemeName === 'dark';

  const containerStyle = {
    minHeight: '100vh',
    background: isDark ? '#0f172a' : '#f8fafc',
    color: theme.text || (isDark ? '#f1f5f9' : '#1e293b'),
    padding: '24px 20px 48px',
  };

  const contentStyle = { maxWidth: 720, margin: '0 auto' };
  const backLinkStyle = {
    display: 'inline-flex', alignItems: 'center', gap: 8,
    color: theme.primary || '#3b82f6', textDecoration: 'none', fontSize: 14, fontWeight: 600, marginBottom: 24,
  };
  const h1Style = { fontSize: '1.75rem', fontWeight: 700, marginBottom: 8 };
  const h2Style = { fontSize: '1.15rem', fontWeight: 600, marginTop: 28, marginBottom: 10 };
  const pStyle = { fontSize: 15, lineHeight: 1.7, marginBottom: 14, color: isDark ? '#cbd5e1' : '#475569' };
  const ulStyle = { marginLeft: 20, marginBottom: 14 };
  const liStyle = { marginBottom: 6, lineHeight: 1.6, color: isDark ? '#cbd5e1' : '#475569' };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <Link to="/login" style={backLinkStyle}><ArrowLeft size={18} /> {t('common.back')}</Link>
        <h1 style={h1Style}>{t('legal.termsTitle')}</h1>
        <p style={pStyle}>{t('legal.termsLastUpdated').replace(/\{\{year\}\}/g, String(new Date().getFullYear()))}</p>

        <h2 style={h2Style}>{t('legal.termsAcceptance')}</h2>
        <p style={pStyle}>{t('legal.termsAcceptanceBody')}</p>

        <h2 style={h2Style}>{t('legal.termsAccount')}</h2>
        <p style={pStyle}>{t('legal.termsAccountBody')}</p>

        <h2 style={h2Style}>{t('legal.termsUse')}</h2>
        <p style={pStyle}>{t('legal.termsUseBody')}</p>

        <h2 style={h2Style}>{t('legal.termsAI')}</h2>
        <p style={pStyle}>{t('legal.termsAIBody')}</p>

        <h2 style={h2Style}>{t('legal.termsAvailability')}</h2>
        <p style={pStyle}>{t('legal.termsAvailabilityBody')}</p>

        <h2 style={h2Style}>{t('legal.termsTermination')}</h2>
        <p style={pStyle}>{t('legal.termsTerminationBody')}</p>

        <h2 style={h2Style}>{t('legal.termsContact')}</h2>
        <p style={pStyle}>{t('legal.termsContactBody')}</p>
      </div>
    </div>
  );
}

export default TermsPage;
